import React from 'react';
import { ApplicationShell } from './helpers/ApplicationShell';
import { AppLayout } from './helpers/AppLayout';
import {
  AuthContext,
  initialAuthContext,
} from 'src/state/providers/AuthProvider';
import { APP_CONTAINER_BASE_URL } from 'src/constants/GlobalConstants';
const RegulatorCentralWidget = () => {
  return (
    <AuthContext.Provider
      value={{
        ...initialAuthContext,
        appContainerBaseUrl: APP_CONTAINER_BASE_URL.REGULATOR_CENTRAL,
      }}
    >
      <ApplicationShell>
        <AppLayout />
      </ApplicationShell>
    </AuthContext.Provider>
  );
};

export { RegulatorCentralWidget };
